import { Injectable, Injector } from '@angular/core'; // Added Injector
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, switchMap, take } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { ApiEndpoints } from 'src/config/api-endpoints';

@Injectable()
export class IdTokenInterceptor implements HttpInterceptor {

  private myClientId = ApiEndpoints.auth0ClientId;

  // Use Injector to avoid the Circular Dependency Crash (NG0200)
  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    
    // Check for your specific API URL
    if (request.url.includes('DWAuthorizeUPSdotcomSession')) {
      
      // Manually get AuthService to break the circular loop
      const auth = this.injector.get(AuthService);

      return auth.idTokenClaims$.pipe(
        take(1),
        switchMap(token => {
          if (token && token.__raw) {
            
            const newRequest = request.clone({
              headers: request.headers
                // Custom headers trigger CORS preflight! 
                // Ensure backend allows 'X-Auth0-Token'
                .set('X-Auth0-Token', token.__raw) 
                .set('client_id', this.myClientId) 
            });

            console.log('✅ Interceptor Added Auth0 Token to header');
            return next.handle(newRequest);
          }
          
          return next.handle(request);
        })
      );
    }

    return next.handle(request);
  }
}